import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import moment from "moment";
import { object, array, string, setLocale } from "yup";
import Select from "react-select";
import ru from "date-fns/locale/ru";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { CloseButton } from "components/CloseButton";
import { toast } from "react-toastify";
import { MySpinner } from "components/MySpinner";
import { Formik } from "formik";
import { useUser } from "features/Users/UserContext";
import { createRouteSheet } from "services/api";
import ReactInputMask from "react-input-mask";
import { dateFormatU } from "utils/format";

registerLocale("ru", ru);

const RouteSheetSchema = object().shape({
  driver: object().required()
});

export const RouteSheetAddModal = ({
  openModal,
  setOpenModal,
  getAndSetRouteSheets
}) => {

  const { admins } = useUser();
  const [loading, setLoading] = useState(false);

  const submitHandler = (values, resetForm) => {
    setLoading(true);
    console.log(values);
    createRouteSheet({
      driver: values.driver?.value,
      date: dateFormatU(values.date),
    })
      .then((res) => {
        toast.success("Маршрутный лист успешно добавлен");
        setOpenModal(false);
        resetForm();
        getAndSetRouteSheets();
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);

      })
      .finally((res) => {
        setLoading(false);
      })
  };

  const onClose = () => {
    setOpenModal(false);
  }

  return (
    <Modal isOpen={openModal} toggle={onClose}>
      <ModalHeader>
        <div className="modal-title-text">Добавить маршрутный лист</div>
        <CloseButton onClick={onClose} />
      </ModalHeader>
      <ModalBody className="m-3">

        {loading && <MySpinner overlay />}

        <Formik
          initialValues={{
            id: null,
            number: null,
            driver: null,
            date: new Date(),
            status: null
          }}
          validationSchema={RouteSheetSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            submitHandler(values, resetForm);
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (

            <form onSubmit={handleSubmit}>

              <Row>
                <Col>
                  <Label className="text-sm-right">Водитель</Label>
                  <Select
                    name="driver"
                    placeholder="Выберите водителя"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={admins.filter((item) => item.department === "drivers")}
                    isSearchable
                    isClearable
                    value={values.driver}
                    onChange={val => setFieldValue("driver", val)}
                    invalid={
                      errors.driver && touched.driver
                        ? errors.driver
                        : null
                    }
                  />
                  <span>{(errors.driver && touched.driver) ? <>{errors.driver}</> : ""}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label>Дата доставки</Label>
                  <DatePicker
                    name="date"
                    placeholderText="Дата доставки"
                    selected={values.date}
                    selectsStart
                    dateFormat="dd.MM.yyyy"
                    locale="ru"
                    onChange={val => setFieldValue("date", val)}
                    className="form-control date"
                    customInput={<ReactInputMask mask={"99.99.9999"} />}
                    invalid={
                      errors.date && touched.date
                        ? errors.date
                        : null
                    }
                  />
                  <span>{(errors.date && touched.date) ? <>{errors.date}</> : ""}</span>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-end mb-3 mt-3">
                  <Button className="ml-2" type="submit">
                    Создать
                  </Button>
                </Col>
              </Row>
            </form>
          )}
        </Formik>


        <div className="d-flex justify-content-end">
          <Button type="button" onClick={onClose} color="secondary">
            Закрыть
          </Button>
        </div>
      </ModalBody>
    </Modal >
  );
};
